import { render, staticRenderFns } from "./ModalTagEmailAutomation.vue?vue&type=template&id=923cd27e&scoped=true&"
import script from "./ModalTagEmailAutomation.vue?vue&type=script&lang=js&"
export * from "./ModalTagEmailAutomation.vue?vue&type=script&lang=js&"
import style0 from "./ModalTagEmailAutomation.vue?vue&type=style&index=0&id=923cd27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923cd27e",
  null
  
)

export default component.exports